import { ActionIcon, TextInput, TextInputProps, useMantineTheme } from '@mantine/core'
import { IconArrowRight, IconSearch } from '@tabler/icons-react'

export default function FindProductInput(props: TextInputProps) {
  const theme = useMantineTheme()
  return (
    <TextInput
      radius="xl"
      size="md"
      placeholder="Wyszukaj produkt po symbolu"
      rightSectionWidth={42}
      leftSection={<IconSearch size={18} stroke={1.5} />}
      rightSection={
        <ActionIcon size={32} radius="xl" color={theme.primaryColor} variant="filled">
          <IconArrowRight size={18} stroke={1.5} />
        </ActionIcon>
      }
      {...props}
    />
  )
}
